/* eslint-disable */
import React from 'react'
import { Box, Flex } from 'grid-styled'
import { connect } from 'react-redux'
import { reset, reduxForm, formValueSelector } from 'redux-form'
import _ from 'lodash'

import { fetchActivation, saveManageInf } from 'alelo-logic/actions'
import { getVehiclesCategory } from '../../../alelo-logic/services/activationService'
import { showModal } from '../../modules/ModalRoot/actions'
import { startSaving, stopSaving } from '../../modules/form-state-actions'
import image from '../../../static/confirmation.png'
import { CONFIRM_UPDATE } from '../../../constants/ModalTypes'

import ImersiveHeader from '../../elements/ImersiveHeader'
import Content from '../../../styles/objects/Content'

import Option from '../../elements/Option'
import Button from 'app/elements/Button'
import IcInfo from 'app/elements/Icon/ic-info'
import IcClose from '../../elements/Icon/ic-close'

import ManageInfoModal from 'app/modules/ManageInfoModal'

import imageError from '../../../static/contestacao.png'

import { AxisField, PlateField, IdentifierField } from './form-fields'

import {
  Title,
  Paragraph,
  TextInfo,
  List,
  BoxGrey,
  ListForm,
  TitleSecond,
  WrapperPill,
  Pill,
  Notice
} from './styles'

import {
  labels,
  titleModal,
  title,
  paragraph,
  textInfo,
  mandatoryInfo,
  titleModalError,
  modalDescriptionError
} from './data.json'

import IcCar from '../../elements/Icon/ic-car'
import IcUtility from '../../elements/Icon/ic-utility'
import IcTruck from '../../elements/Icon/ic-truck'
import IcBus from '../../elements/Icon/ic-bus'

class Activation extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      selected: '',
      axis: [],
      modalIsOpen: false,
      manageInfo: {
        informacao1: null,
        informacao2: null,
        informacao3: null
      }
    }
  }

  setOption = selected => {
    this.setState({ selected }, () => {
      const { selected } = this.state

      if (selected === 'caminhao' || selected === 'onibus') this.getCategory(selected)
    })
  }

  componentDidMount() {
    this.props.dispatchReset()
  }

  getCategory = selected => {
    getVehiclesCategory(selected).then(response => {
      const optionCategory = response.map(item => {
        return Object.assign(
          {},
          {
            value: item.id,
            label: item.descricao
          }
        )
      })
      this.setState({ axis: optionCategory })
    })
  }

  handleSubmit = values => {
    const { selected, manageInfo } = this.state
    const { accountPlans } = this.props
    const { plans, activePlanId } = accountPlans
    const currentPlan = plans.find(plan => String(plan.id) === String(activePlanId))

    const formatValues = Object.assign({ typeCar: selected }, values, {
      accountId: currentPlan.accountId,
      type: currentPlan.plan.type
    })

    const data = Object.values(manageInfo).map(item => {
      if (item != null) {
        item.codIdentificador = formatValues.identifier
        item.conta = formatValues.accountId
        item.placa = formatValues.plate

        return item
      }
    })
    this.props.fetchActivation(formatValues, _.compact(data))
  }

  toggleModal = () => {
    this.setState({ modalIsOpen: !this.state.modalIsOpen })
  }

  addManageInf = values => {
    const { manageInfo } = this.state

    switch (values.tipoInfo) {
      case 'INFORMACAO_1':
        manageInfo.informacao1 = values
        break

      case 'INFORMACAO_2':
        manageInfo.informacao2 = values
        break

      case 'INFORMACAO_3':
        manageInfo.informacao3 = values
        break
    }

    this.setState({ manageInfo })
    this.toggleModal()
  }

  handleDeletePil = typeInfo => {
    const { manageInfo } = this.state

    switch (typeInfo) {
      case 'INFORMACAO_1':
        manageInfo.informacao1 = ''
        break

      case 'INFORMACAO_2':
        manageInfo.informacao2 = ''
        break

      case 'INFORMACAO_3':
        manageInfo.informacao3 = ''
        break
    }

    this.setState({ manageInfo })
  }

  render() {
    const { selected, axis, modalIsOpen, manageInfo } = this.state
    const { fieldPlate, fieldIdentifier, saving, accountPlans: { activePlanId } } = this.props
    const showAxios = selected === 'caminhao' || selected === 'onibus'
    const urlBack = `/minha-veloe/${activePlanId}/identificadores`
    return (
      <Box>
        <div>
          <ImersiveHeader text="Voltar" url={urlBack} />
        </div>

        <Content>
          <Title>{title}</Title>
          <Paragraph>{paragraph}</Paragraph>
        </Content>
        <form onSubmit={this.props.handleSubmit(this.handleSubmit)}>
        <BoxGrey>
          <Content>
            <TextInfo>{textInfo}</TextInfo>
            <List>
              <Option
                active={selected === 'carro-passeio'}
                description="Carro de passeio"
                icon={<IcCar />}
                setOption={this.setOption}
                value="carro-passeio"
              />
              <Option
                active={selected === 'carro-utilitario'}
                description="Carro utilitário"
                icon={<IcUtility />}
                setOption={this.setOption}
                value="carro-utilitario"
              />
              <Option
                active={selected === 'caminhao'}
                description="Caminhão"
                icon={<IcTruck />}
                setOption={this.setOption}
                value="caminhao"
              />
              <Option
                active={selected === 'onibus'}
                description="Ônibus"
                icon={<IcBus />}
                setOption={this.setOption}
                value="onibus"
              />
            </List>


              <ListForm>
                <Box width={1} mb={1}>
                  <PlateField />
                </Box>
                {showAxios && (
                  <Box width={1} mb={1}>
                    <AxisField axis={axis} />
                  </Box>
                )}
                <Box width={1} mb={1}>
                  <IdentifierField />
                </Box>
              </ListForm>
              </Content>
        </BoxGrey>

        <Content>



              <Notice>
                <IcInfo />
                 <span>Depois de ativar o adesivo Veloe, você já pode usar nos estacionamentos, mas é importante <b>aguardar até 6 horas pra passar livre e sem filas nos pedágios</b> das rodovias de todo o Brasil.</span>
              </Notice>

              <TitleSecond>Informações Gerenciais</TitleSecond>
              <Paragraph noMargin>
                Para facilitar o gerenciamento das suas transações, você pode adicionar até 3
                informações gerenciais por VeloeTag, que serão apresentadas nos seus extratos e
                faturas.
              </Paragraph>
              <TextInfo initialCase noMargin>
                Você pode adicionar as informações posteriormente no menu "Minhas VeloeTags"
              </TextInfo>

              <WrapperPill>
                {!manageInfo.informacao1 &&
                  !manageInfo.informacao2 &&
                  !manageInfo.informacao3 && <Pill noSelected>Nenhuma informação adicionada.</Pill>}

                {manageInfo.informacao1 && (
                  <Pill>
                    1. {manageInfo.informacao1.descricao}
                    <span onClick={() => this.handleDeletePil('INFORMACAO_1')}>
                      <IcClose />
                    </span>
                  </Pill>
                )}

                {manageInfo.informacao2 && (
                  <Pill>
                    2. {manageInfo.informacao2.descricao}
                    <span onClick={() => this.handleDeletePil('INFORMACAO_2')}>
                      <IcClose />
                    </span>
                  </Pill>
                )}

                {manageInfo.informacao3 && (
                  <Pill>
                    3. {manageInfo.informacao3.descricao}
                    <span onClick={() => this.handleDeletePil('INFORMACAO_3')}>
                      <IcClose />
                    </span>
                  </Pill>
                )}
              </WrapperPill>

              <Box width={1}>
                <Button
                  buttonType="darkBlue"
                  text={labels.addInformation}
                  onClick={() => this.toggleModal()}
                />
              </Box>

              <Flex align="center" justify="flex-end" mt={[0, '10px']} mb={32}>
                <Button
                  text={labels.submitButton}
                  type="submit"
                  loading={saving}
                  width="200px"
                  disabled={saving || (!fieldPlate || !fieldIdentifier || selected === '')}
                />
              </Flex>
              </Content>
            </form>
        {modalIsOpen ? (
          <ManageInfoModal
            isOpen={modalIsOpen}
            toggleModal={this.toggleModal}
            modalStart="include"
            match={this.props.match}
            controlled
            handleSubmitExternal={values => this.addManageInf(values)}
          />
        ) : null}
      </Box>
    )
  }
}

export const mapStateToProps = state => {
  const selector = formValueSelector('activationForm')
  return {
    fieldPlate: selector(state, 'plate'),
    fieldIdentifier: selector(state, 'identifier'),
    saving: state.reducer.formState.saving,
    accountPlans: state.reducer.accountPlans
  }
}

export const mapDispatchToProps = (dispatch, ownProps) => ({
  initFormState: () => dispatch(stopSaving()),
  dispatchReset: () => {
    dispatch(reset('activationForm'))
  },
  fetchActivation: (values, manageInfs) => {
    dispatch(startSaving())
    dispatch(fetchActivation(values))
      .then(async resp => {
        if (resp) {
          if (resp.status) {
            const total = manageInfs.length

            if (total === 1) {
              await manageInfs.map(async data => {
                await dispatch(saveManageInf({ data }))
                  .then(() => {
                    dispatch(stopSaving())
                    ownProps.history.push('/identificadores/ativacao/sucesso')
                  })
                  .catch(erro => console.error(erro))
              })
            } else if (total === 2) {
              Promise.all([
                dispatch(saveManageInf({ data: manageInfs[0] })),
                dispatch(saveManageInf({ data: manageInfs[1] }))
              ])
                .then(() => {
                  dispatch(stopSaving())
                  ownProps.history.push('/identificadores/ativacao/sucesso')
                })
                .catch(erro => console.error(erro))
            } else if (total === 3) {
              Promise.all([
                dispatch(saveManageInf({ data: manageInfs[0] })),
                dispatch(saveManageInf({ data: manageInfs[1] })),
                dispatch(saveManageInf({ data: manageInfs[2] }))
              ])
                .then(() => {
                  dispatch(stopSaving())
                  ownProps.history.push('/identificadores/ativacao/sucesso')
                })
                .catch(erro => console.error(erro))
            } else {
              dispatch(stopSaving())
              ownProps.history.push('/identificadores/ativacao/sucesso')
            }
          } else {
            dispatch(showModal(CONFIRM_UPDATE, { modalTitle: titleModal, image }))
          }
          window.dataLayer = window.dataLayer || []
          window.dataLayer.push({
            event: 'event',
            eventCategory: 'veloe:area-logado:ativar-identificador',
            eventAction: 'ativar-tag',
            eventLabel: 'tentativa:sucesso',
            dimension5: values.identifier
          })
        }
      })
      .catch(e => {
        e.json().then(response => {
          dispatch(
            showModal(CONFIRM_UPDATE, {
              modalTitle: response.title || titleModalError,
              modalDescription: response.message || modalDescriptionError,
              image: imageError
            })
          )
        })
        dispatch(stopSaving())
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: 'event',
          eventCategory: 'veloe:area-logado:ativar-identificador',
          eventAction: 'ativar-tag',
          eventLabel: 'tentativa:erro',
          dimension5: values.identifier
        })
      })
  }
})

const form = reduxForm({
  form: 'activationForm',
  destroyOnUnmount: false
})(Activation)

export default connect(mapStateToProps, mapDispatchToProps)(form)



// WEBPACK FOOTER //
// ./src/app/pages/Activation/index.js